export default __webpack_public_path__ + "static/media/ranch-bottle-photo-cut3.96fd9e86.png";